import { formatCurrency2String } from 'src/utils/number/currency'

const day = 60 * 60 * 1000 * 24

export const getIntervalByPeriod = period =>
  ({
    '1D': day,
    '7D': 7 * day,
    '1M': 30 * day,
    '6M': 180 * day,
    '1Y': 365 * day,
  }[period])

export const formatCurrency = (number, withoutFloat) =>
  formatCurrency2String(number, false, `0,0${withoutFloat ? '' : '.00'}`)
